import React, { Component } from "react";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { discussionClient } from "../../AxiosClient";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { Badge, TextField, Tooltip } from "@material-ui/core";
import { Trans, withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Fullscreen from "@material-ui/icons/Fullscreen";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import AreYouSureDialog from "../dialog/AreYouSureDialog";
import MenuItem from "@material-ui/core/MenuItem";
import ButtonMenu from "../ButtonMenu";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import TaxonomyTree from "../taxonomy/TaxonomyTree";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DisplayUser from "../../components/user/DisplayUser";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import moment from "moment";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  alert: {
    color: theme.palette.error.light,
  },
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
});

export class ItemDiscussions extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    extendedString: "",
    discussion: {},
    discussionEntries: [],
    openAreYouSure: false,
    selectedNode: null,
    openRenameDiscussion: false,
    discussionRename: "",
  };
  componentDidMount() {
    this.setState({ discussion: this.props.data });
    this.extendedInfo(this.props.extendedSettings);
    this.secondaryInfo(this.props.listSettings);
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }
  render() {
    const { classes } = this.props;
    let canModerate =
      this.props.canModerate &&
      (this.props.user.userPermits.roles.forumModerator ||
        this.props.user.userPermits.roles.administrator ||
        this.props.user.userPermits.roles.administrator.systemManager);
    return (
      <KpsListItem
        preText={this.props.preText}
        isPortlet={this.props.isPortlet}
        icon={
          this.props.data.discussionRead ? (
            <Tooltip
              title={
                <Typography>{this.props.t("required_reading_read")}</Typography>
              }
            >
              <ChatBubbleIcon />
            </Tooltip>
          ) : (
            <Tooltip
              title={
                <Typography>
                  {this.props.t("required_reading_unread")}
                </Typography>
              }
            >
              <SmsFailedIcon className={classes.alert} />
            </Tooltip>
          )
        }
        onItemClick={
          this.props.discussionPortlet
            ? this.onItemClick
            : () => this.props.onItemClick(this.props.data)
        }
        extendedString={this.state.extendedString}
        provided={this.props.provided}
        secondaryAction={
          (canModerate || !this.props.noFullscreen) && (
            <div className={classes.noWrap}>
              {canModerate && (
                <ButtonMenu>
                  {!this.props.noMove && (
                    <MenuItem onClick={this.openEditAttachment}>
                      Move discussion
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={(e) => {
                      this.setState({
                        openRenameDiscussion: true,
                        discussionRename: this.props.data.title,
                      });
                      e.stopPropagation();
                    }}
                  >
                    Rename discussion
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({ openAreYouSure: true });
                    }}
                  >
                    <Trans i18nKey="portlet_attachment_delete_text" />
                  </MenuItem>
                </ButtonMenu>
              )}
              {!this.props.noFullscreen && (
                <Tooltip title={this.props.t("global_fullscreen")}>
                  <IconButton onClick={this.onFullscreen}>
                    <Fullscreen />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )
        }
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.data.genre === "EXPERT_QUESTION" && (
          <ListItemIcon>
            <Tooltip
              title={
                <Typography>
                  {this.props.t("global_expert_question_singular")}
                </Typography>
              }
            >
              <SupervisedUserCircleIcon />
            </Tooltip>
          </ListItemIcon>
        )}
        {this.props.fullscreen ? (
          <Link
            id="discussion-link"
            component="button"
            color="inherit"
            underline="none"
            // onClick={this.onItemClick}
            style={{ textAlign: "left" }}
          >
            {this.props.data.title}
          </Link>
        ) : (
          <ListItemText
            primary={this.primaryInfo()}
            style={{ overflowWrap: "anywhere" }}
            secondary={this.state.secondaryString}
          />
        )}
        {this.state.openAreYouSure && (
          <AreYouSureDialog
            open={this.state.openAreYouSure}
            onClose={() => this.setState({ openAreYouSure: false })}
            onSubmit={this.delete}
          >
            Are you sure you want to delete the discussion{" "}
            {this.props.data.title}
          </AreYouSureDialog>
        )}
        {this.state.openRenameDiscussion && (
          <Dialog
            maxWidth="lg"
            open={this.state.openRenameDiscussion}
            onClick={(e) => e.stopPropagation()}
          >
            <DialogContent>
              <KpsTextField
                onChange={(e) => {
                  this.setState({
                    discussionRename: e.target.value,
                  });
                }}
                value={this.state.discussionRename}
                label="Discussion name"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.resetRename}>
                <Trans i18nKey="global_cancel" />
              </Button>
              <Button
                disabled={
                  this.state.discussionRename === null ||
                  this.state.discussionRename === ""
                }
                onClick={this.renameDiscussion}
              >
                Accept
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.openMoveDiscussionDialog && (
          <Dialog
            maxWidth="lg"
            open={this.state.openMoveDiscussionDialog}
            onClick={(e) => e.stopPropagation()}
          >
            <DialogContent>
              <TaxonomyTree
                noElevate
                // includeRoledUsers
                onNodeSelected={(node) => this.setState({ selectedNode: node })}
                allowedSelections={["taxonomy", "topic"]}
                filter={this.props.filter ? this.props.filter : []}
                treeType="discussions"
              />
              <DialogActions>
                <Button
                  onClick={() =>
                    this.setState({ openMoveDiscussionDialog: false })
                  }
                >
                  <Trans i18nKey="global_cancel" />
                </Button>
                <Button
                  disabled={!this.state.selectedNode}
                  onClick={this.moveDiscussion}
                >
                  Accept
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        )}
      </KpsListItem>
    );
  }
  resetRename = () => {
    this.setState({ openRenameDiscussion: false, discussionRename: "" });
  };
  renameDiscussion = () => {
    let discussion = { ...this.props.data };
    discussion.title = this.state.discussionRename;
    discussionClient
      .patch(`/discussion/${discussion.discussionId}`, discussion)
      .then((res) => {
        this.resetRename();
        this.props.refreshDiscussions();
        this.props.openSnackbar &&
          this.props.openSnackbar(
            `The discussion ${discussion.title} has been renamed`
          );
      });
  };
  openEditAttachment = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ openMoveDiscussionDialog: true });
  };
  moveDiscussion = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let discussion = { ...this.props.data };
    if (this.state.selectedNode.type === "taxonomy") {
      discussion.type = "TAXONOMY_NODE";
    } else if (this.state.selectedNode.type === "topic") {
      discussion.type = "TOPIC";
    }
    discussion.itemId = this.state.selectedNode.id;
    discussionClient
      .patch(`/discussion/${discussion.discussionId}`, discussion)
      .then((res) => {
        this.setState({ openMoveDiscussionDialog: false });
        this.props.openSnackbar &&
          this.props.openSnackbar(
            `The discussion ${discussion.title} has been moved`
          );
        this.props.removeDiscussion(discussion.discussionId);
      });
  };
  showDiscussionList = () => {
    this.setState({
      viewDiscussion: !this.state.viewDiscussion,
    });
  };
  delete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let discussionId = this.props.data.discussionId;
    discussionClient.delete(`/discussion/${discussionId}`).then((res) => {
      this.setState({ openAreYouSure: false });
      this.props.removeDiscussion(discussionId);
    });
  };
  onFullscreen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.history.push({
      pathname: `/full/discussion/${this.props.data.discussionId}`,
      state: { discussion: this.props.data },
    });
  };
  onItemClick = () => {
    this.props.data.type === "DOCUMENT"
      ? this.props.history.push({
          pathname: `/full/document/${this.props.data.itemId}`,
          state: { discussionId: this.props.data.discussionId },
        })
      : this.props.data.type === "KNOWLEDGE_ITEM"
        ? this.props.history.push({
            pathname: `/full/knowledgeitem/${this.props.data.itemId}`,
            state: { discussionId: this.props.data.discussionId },
          })
        : this.props.history.push({
            pathname: `/full/discussion/${this.props.data.discussionId}`,
            state: { discussionId: this.props.data.discussionId },
          });
  };
  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.discussionOptions.length; i++) {
        settings.push({ label: this.props.discussionOptions[i], order: i });
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "settings_discussions_posted_by" && (
          <TableCell>
            <DisplayUser
              userId={this.props.data.postedById}
              user={this.props.data.postedBy}
            />
          </TableCell>
        )}
        {setting.label === "settings_discussions_location" && (
          <TableCell>
            {
              <DisplayLocation
                type={this.props.data.type}
                itemId={this.props.data.itemId}
                topicId={this.props.data.topicId}
                title={this.props.data.targetTitle}
              />
            }
          </TableCell>
        )}
        {setting.label === "settings_discussions_date_created" && (
          <TableCell>
            {!!this.props.data.time
              ? moment(this.props.data.time).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_discussions_number_posts" && (
          <TableCell>{this.props.data.numberOfEntries}</TableCell>
        )}
        {setting.label === "settings_discussions_number_views" && (
          <TableCell>
            {this.props.data.views ? this.props.data.views : 0}
          </TableCell>
        )}
        {setting.label === "settings_discussions_date_last_post" && (
          <TableCell>
            {moment(this.props.data.lastPostDate).format("LLL")}
          </TableCell>
        )}
        {setting.label === "settings_expert_question_status" && (
          <TableCell>
            {this.props.data.locked
              ? this.getLockedIconAndTooltip()
              : this.props.data.expertQuestionStatus}
          </TableCell>
        )}
        {setting.label === "settings_expert_question_visibility" && (
          <TableCell>{this.props.data.expertQuestionVisibility}</TableCell>
        )}
      </>
    );
  };
  primaryInfo() {
    let info = this.props.data.title;
    return info;
  }
  returnSettingItem = (settings) => {
    const { theme, classes } = this.props;
    let fontWeight = { fontWeight: this.props.fullscreen ? "bold" : "normal" };

    return (
      <span className={classes.iconSpan}>
        {settings === "settings_discussions_posted_by" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_discussions_posted_by")}
            </div>
            <div>: {this.props.data.postedById}&nbsp;</div>
          </div>
        )}
        {settings === "settings_discussions_location" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_discussions_location")}
            </div>
            <div style={{ marginLeft: theme.spacing(1) }}>
              <DisplayLocation
                type={this.props.data.type}
                itemId={this.props.data.itemId}
                topicId={this.props.data.topicId}
                title={this.props.data.targetTitle}
              />
            </div>
          </div>
        )}
        {settings === "settings_discussions_date_created" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_discussions_date_created")}
            </div>
            <div>: {moment(this.props.data.time).format("LLL")}&nbsp;</div>
          </div>
        )}
        {settings === "settings_discussions_number_posts" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_discussions_number_posts")}
            </div>
            <div>: {this.props.data.numberOfEntries}&nbsp;</div>
          </div>
        )}
        {settings === "settings_discussions_number_views" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_discussions_number_views")}
            </div>
            <div>
              : {this.props.data.views ? this.props.data.views : 0}&nbsp;
            </div>
          </div>
        )}
        {settings === "settings_discussions_date_last_post" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_discussions_date_last_post")}
            </div>
            <div>
              : {moment(this.props.data.lastPostDate).format("LLL")}&nbsp;
            </div>
          </div>
        )}
      </span>
    );
  };
  secondaryInfo = (settings) => {
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        if (this.props.expertQuestionOptions) {
          for (let i = 0; i < this.props.expertQuestionOptions.length; i++) {
            settings.push({
              label: this.props.expertQuestionOptions[i],
              order: i,
            });
          }
        }
      } else {
        if (!settings) {
          settings = JSON.parse(this.props.fullscreenSettings);
        } else {
          try {
            settings = JSON.parse(settings);
          } catch (x) {}
        }
      }
      this.setState({ secondaryString: "" });
    } else {
      if (this.props.secondaryInfo) {
        return this.props.secondaryInfo;
      }
      if (!settings) {
        settings = "settings_discussions_date_last_post";
      }

      const { classes } = this.props;
      let info = (
        <div>
          {this.props.fullscreen && settings
            ? settings.map((setting) => {
                return this.returnSettingItem(setting);
              })
            : this.returnSettingItem(settings)}
        </div>
      );
      this.setState({ secondaryString: info });
    }
  };
  extendedInfo(settings) {
    const { classes } = this.props;
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.discussionOptions.length; i++) {
        settings.push({ label: this.props.discussionOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          let name = "";
          if (this.props.data.type === "TAXONOMY_NODE") {
            name = "Taxonomy node:";
          } else if (this.props.data.type === "DOCUMENT") {
            name = "Document:";
          } else {
            name = "Knowledge item:";
          }
          return (
            <TableRow key={idx}>
              <TableCell component="th" scope="row">
                {this.props.t(setting.label)}
              </TableCell>
              {setting.label === "settings_discussions_posted_by" && (
                <TableCell>
                  <DisplayUser
                    userId={this.props.data.postedById}
                    user={this.props.data.postedBy}
                  />
                </TableCell>
              )}
              {setting.label === "settings_discussions_location" && (
                <TableCell>
                  {
                    <DisplayLocation
                      type={this.props.data.type}
                      itemId={this.props.data.itemId}
                      topicId={this.props.data.topicId}
                      title={this.props.data.targetTitle}
                    />
                  }
                </TableCell>
              )}
              {setting.label === "settings_discussions_date_created" && (
                <TableCell>
                  {moment(this.props.data.time).format("LLL")}
                </TableCell>
              )}
              {setting.label === "settings_discussions_number_posts" && (
                <TableCell>{this.props.data.numberOfEntries}</TableCell>
              )}
              {setting.label === "settings_discussions_number_views" && (
                <TableCell>
                  {this.props.data.views ? this.props.data.views : 0}
                </TableCell>
              )}
              {setting.label === "settings_discussions_date_last_post" && (
                <TableCell>
                  {moment(this.props.data.lastPostDate).format("LLL")}
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString });
  }
}
const mapStateToProps = (state) => ({
  discussionOptions: state.selectionOption.discussionSettingsOptions,
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(
  withTheme(withStyles(styles)(withRouter(withTranslation()(ItemDiscussions))))
);
